<div class="card text-decoration-none bg-opacity-30 bg-white">
  <div class="card-body d-flex align-items-center text m-5px text-truncate text-uppercase">
    <div class="flex-fill">
      <div class="mb-1">{{widget.name}} <a data-toggle="card-expand" class="text text-decoration-none" (click)="refresh()" data-bs-original-title="" title=""><i class="fa fa-refresh"></i></a></div>
      
      <h2 *ngIf="variance" title="{{pointA.value}} ({{w.displayA}}) v {{pointB.value}} ({{w.displayB}})">
        {{variance}}<small *ngIf="w">{{w.units}}</small>
      </h2>
    </div>
    <div class="opacity-5">
      <i class="fa fa-4x"></i>
    </div>
  </div>
  <div class="card-arrow">
    <div class="card-arrow-top-left"></div>
    <div class="card-arrow-top-right"></div>
    <div class="card-arrow-bottom-left"></div>
    <div class="card-arrow-bottom-right"></div>
  </div>
</div>